<template>
    <section class="page">
    </section>
</template>

<script>
import greetings from "@/data/main/greetings"

export default {
  name: 'Settings',
  methods: {
      async login(data) {
        this.$store.dispatch('addNotification', {message: `Подтверждение почтового ящика ${data.message.email} прошло успешно!`})
        let tokens = data.tokens;
        let user = data.user;
        this.$axios.defaults.headers.common['Authorization'] = tokens.accessToken;
        this.$axios.defaults.headers.common['Refresh'] = tokens.refreshToken;
        await localStorage.setItem('token', tokens.accessToken)
        await localStorage.setItem('refresh', tokens.refreshToken)
        await localStorage.setItem('user', JSON.stringify(data.user))
        this.$router.push('/events')
        this.$store.dispatch('setModal', greetings )
        try {
            user ? window.ReactNativeWebView.postMessage(JSON.stringify(user)) : ''
        } catch (error) {
            error
        }
      }
  },
  created() {
        document.title = this.$route.meta.title;
        let hash = this.$route.params.hash;
        if (hash) {
            
            this.$axios.post(`/api/auth/activation`, {hash, browser: navigator.userAgent})
            .then(response => {
                if (response.data) {
                    this.login(response.data)
                } else {
                    this.$router.push('/404')
                }
            })
            .catch(() => {
                this.$router.push('/404')
            });
        } else {
            this.$router.push('/404')
        }
        
    }
}

</script>